import { ImagesService } from './images.service';
import { StatesService } from './states.service';

export class LogicProviderFactory {
	addProviderTypes(dependencies: any[]) {
		dependencies.push({ provide: StatesService, useClass: StatesService, });
		dependencies.push({ provide: ImagesService, useClass: ImagesService })
	}
}
